import { jsx as _jsx } from "react/jsx-runtime";
import Skeleton from '@shared/ui/Skeleton';
import styles from './ProjectSummarySkeleton.module.scss';
export function ProjectSummarySkeleton() {
    return (_jsx("div", { className: styles.container, children: Array.from({ length: 240 }).map((_, index) => (_jsx(Skeleton, { className: styles.skeleton }, index))) }));
}
